import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon, Text, Button } from '../../Atoms';
import PageTitle from '../../Components/Dashboard/PageTitle';
import { COLOR_BUTTON, COTISATION } from '../../Config/Config';
import { Modal } from '../../Molecules';
import OrganismPaginatedTable from '../../Organisms/OrganismPaginatedTable/OrganismPaginatedTable';

const TemplateCotisation = ({
                              columnTitles,
                              visibleRows,
                              data = [],
                              onClickPrelevement,
                              handleSubmit,
                              handleInputChange,
                              methodePaiement,
                              montantApayer,
                              montantAcompte,
                              codeTiers
                            }) => {

  // Ajout de l'état pour la modale PaymentInfo
  const [showModalPaymentInfo, setShowModalPaymentInfo] = useState(false);

  // Fonction pour ouvrir la modale
  const handleOpenModalPaymentInfo = () => {
    setShowModalPaymentInfo(true);
  };

  // Fonction pour fermer la modale
  const handleCloseModalPaymentInfo = () => {
    setShowModalPaymentInfo(false);
  };

// template-scroll template-container  mt-20 d-flex flex-column
  return (
    <div className="template-cotisation template-scroll pl-30 pb-5">

      <div className='template-cotisation-liste pb-5'>
        <div>
          <PageTitle
            titleText="Mes cotisations"
            canGoBack={false}
          />
        </div>
        <div className='d-flex justify-content-between'>
          <div className='align-self-center d-flex justify-content-between m-1'>
            <Text
              text='Moyen de paiement actuel : '
              type="h7"
              className='p-1'
            />

            <Text
              text={methodePaiement}
              type="h8"
              className='align-self-center p-1'
            />
          </div>
          <div className='align-self-center d-flex justify-content-between m-1'>
            <Text
              text='Montant Total à payer : '
              type="h4"
              className='p-1'
            />
            <Text
              text={`${montantApayer} €`}
              type="h4"
              className='align-self-center p-1'
            />
          </div>
        </div>

        {montantAcompte > 0 && (
          <div className="d-flex justify-content-end">
            <div className="d-flex justify-content-end m-1">
              <Text
                text="Acompte déjà payé : "
                type="h7"
                className='p-1'
              />
              <Text
                text={`${montantAcompte} €`}
                type="h8"
                className='align-self-center p-1'
              />
            </div>
          </div>
        )}

        {/* d-flex justify-content-between mb-5 */}
        <div className='d-flex justify-content-end m-2 mb-10'>
          {/* <div */}
          {/*  className='align-self-center d-flex justify-content-between m-1 p-4 pointer-cusrsor shadow rounded' */}
          {/*  onClick={() => onClickPrelevement()} */}
          {/* > */}
          {/*  <Text */}
          {/*    text='Je souhaite passer au prélèvement automatique' */}
          {/*    type="h8" */}
          {/*    className='p-1 font-weight-bold' */}
          {/*  /> */}
          {/*  <Icon */}
          {/*    size={"15"} */}
          {/*    icon="SortTop" */}
          {/*    className="faq-icon-next-step" */}
          {/*    style={{ cursor: 'pointer' }} */}
          {/*  /> */}

          {/* </div> */}

          <div className='align-self-center'>
            <Button
              text='Je règle ma facture'
              className='button-big-round'
              onClick={handleOpenModalPaymentInfo}
              color={COLOR_BUTTON.SECOND_RED}
            />
          </div>

          {/* Ajout de la modale */}
          <Modal
            show={showModalPaymentInfo}
            onHide={handleCloseModalPaymentInfo}
            centered={true}
            showIconClose={false}
            contentClassName={'content-modal-confirm-password'}
          >
            <div className="full-container">
              <Icon
                icon="BigX"
                className="icon-close-modal-confim-password"
                size="20px"
                onClick={handleCloseModalPaymentInfo}
              />
              <Text
                text={`Régularisation de votre cotisation`}
                className="title-modal-confirm-password"
              />

              <p style={{ fontFamily: 'Mont', marginBottom: 10, textAlign: 'left' }}>
                Pour régulariser votre situation, merci d’effectuer un virement bancaire en utilisant les
                coordonnées suivantes : <br /><br />
                <b>Titulaire :</b> {COTISATION.TITULAIRE} <br />
                <b>IBAN :</b> {COTISATION.IBAN} <br />
                <b>BIC :</b> {COTISATION.BIC} <br />
                <b>Référence à indiquer </b>: {codeTiers} <br /><br />
                <span style={{ color: 'red' }}>Montant total à payer </span>: <b>{montantApayer} €</b> <br />
                ⚠️ Veillez à bien mentionner la <b>référence du virement</b> afin de garantir un traitement rapide
                de votre paiement.<br /><br />
                <span style={{ color: 'red' }}>Important</span> : Si le règlement a déjà été effectué, un délai de
                quelques jours peut être nécessaire avant la mise à jour de votre cotisation sur votre
                espace. <br /><br />
                Merci, <br />
                <b>L’équipe CGRM</b>
              </p>
            </div>
          </Modal>

        </div>
        <div className='mt-4 pt-3'>
          <div className='m-2'>
            <Text
              text='Voici vos dernières échéances :'
              type="h8"
              className="mb-3"
            />
          </div>
          <div className="pb-5">
            <OrganismPaginatedTable data={data} columnTitles={columnTitles} />
          </div>
          {/* <div className='text-center mt-3'> */}
          {/*  <Button */}
          {/*    text='Afficher plus' */}
          {/*    className='' */}
          {/*    onClick={() => false} */}
          {/*    color={COLOR_BUTTON.BLACK} */}
          {/*  /> */}
          {/* </div> */}
        </div>

      </div>
    </div>
  );
};

TemplateCotisation.propTypes = {
  columnTitles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    })
  ).isRequired,
  visibleRows: PropTypes.number,
  data: PropTypes.array,
  onClickPrelevement: PropTypes.func.isRequired, // Fonction obligatoire
  handleSubmit: PropTypes.func.isRequired, // Fonction obligatoire
  handleInputChange: PropTypes.func.isRequired, // Fonction obligatoire
  methodePaiement: PropTypes.string.isRequired, // Chaîne obligatoire
  montantApayer: PropTypes.number.isRequired, // Nombre obligatoire
  montantAcompte: PropTypes.number, // Nombre optionnel
  codeTiers: PropTypes.string.isRequired, // Chaîne obligatoire
};

export default TemplateCotisation;
